import { UseScrollTriggerOptions } from '@mui/material/useScrollTrigger/useScrollTrigger';
import axios from 'axios';
import Cookies from 'js-cookie';


// Axios auth config 

const getConfig = () => { 

    const token = Cookies.get('adminJwt');

    const config = { 
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }; 

    return config; 

}; 


// --- 

export const getDoctors = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctors`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error getting a list of doctors:', error.message);
    };

};

// -- 

export const createDoctor = async (firstName: string, lastName: string, email: string, groupId: string, groupName: string) => {

    try {

        const content = { 
            firstName: firstName, 
            lastName: lastName, 
            email: email,
            groupId: groupId, 
            groupName: groupName
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/create/doctor`, content, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error creating a doctor: createDoctor()', error.message);
    };

};

// -- 

export const getTeamMembers = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/team`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error getting a list of team members:', error.message);
    };

};

// -- 

export const getReferrals = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/referrals`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error getting a list of referrals:', error.message);
    };

};

// -- 

export const getSupportTickets = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/support/tickets`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getSupportTickets()', error.message);
    };

};

// -- 

export const getTicketDetails = async (author: string) => { 

    try { 

        const content = { 
            author: author
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/support/ticketInfo`, content, getConfig()); 

        if (res.status === 200) { 

            return res.data.author; 

        }; 

    } catch (error: any) {
        console.error('Error getting the ticket details:', error.message);
    }; 

}; 

// -- 

export const createSupportTicket = async (author: string, status?: string, category?: string, description?: string) => { 

    try { 

        const content = { 
            author: author,
            status: status,
            category: category, 
            description: description
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/support/tickets/create`, content, getConfig()); 

        if (res.status === 200) { 

            return res; 

        }; 

    } catch (error: any) {
        console.error('Error creating a support ticket:', error.message);
    }; 

}; 

// -- 

export const archiveSupportTicket = async (supportTicketId: string) => { 

    try { 

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/support/tickets/archive/${supportTicketId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error in archiveSupportTicket():', error.message);
    }; 

}; 

// --- 

export const createDevHackerAccount = async (email: string, firstName: string, lastName: string) => {

    try {

        const content = { 
            email: email, 
            firstName: firstName, 
            lastName: lastName
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/create/hacker`, content); 

        return res; 

    } catch (error: any) {
        console.error('Error creating a dev Hacker account.', error.message);
    };

};

// -- 

export const createHacker = async (email: string, firstName: string, lastName: string, main: boolean) => {

    try {

        const content = { 
            email: email, 
            firstName: firstName, 
            lastName: lastName,
            main: main, 
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/create/hacker`, content, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error creating a hacker.', error.message);
    };

};

// -- 

interface CreateTeamMemberProps { 
    firstName: string; 
    lastName: string; 
    email: string; 
}

export const createTeamMember = async (config: CreateTeamMemberProps) => {

    try {

        const content = { 
            firstName: config.firstName, 
            lastName: config.lastName,
            email: config.email 
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/create/member`, content, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error creating a new team member.', error.message);
    };

};

// -- 

export const getPatients = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/patients`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error getting a list of patients:', error.message);
    };

};

// -- 

export const getHackers = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/hackers`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error getting a list of hackers:', error.message);
    };

};

// -- 

export const deletePatient = async (patientId: string) => {

    try {

        const res = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/hacker/patient/${patientId}`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error deleting a patient:', error.message);
    };

};

// -- 

export const deactivateDoctor = async (doctorId: string) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/deactivate/${doctorId}`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error deactivating a doctor:', error.message);
    };

};

// -- 

export const reactivateDoctor = async (doctorId: string) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/reactivate/${doctorId}`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error reactivating a doctor:', error.message);
    };

};

// -- 

export const getDashboardData = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/data`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving dashboard data.', error.message);
    };

};

// -- 

export const getNumberOfDoctorsByDate = async (date: any) => {

    try {

        const content = { 
            date: date,
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/data/doctors/date`, content, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving the dashboard doctor date.', error.message);
    };

};

// -- 

export const getNumberOfPatientsByDate = async (date: any) => {

    try {

        const content = { 
            date: date,
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/data/patients/date`, content, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving the dashboard patient date.', error.message);
    };

};

// -- 

export const getSecurityData = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/data/security`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving dashboard security data.', error.message);
    };

};

// -- 

export const getActivityData = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/data/activity`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving dashboard activity data.', error.message);
    };

};

// -- 

export const getActivityByHour = async (date: any) => {

    try {

        const content = { 
            date: date,
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/data/activity/hour`, content, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving the activity by hour.', error.message);
    };

};

// -- 

export const requestDoctorDeletion = async (doctorId: any) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/account/deletion/request/${doctorId}`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error in requestDoctorDeletion.', error.message);
    };

};

// -- 

export const confirmDoctorDeletion = async (deletedAccountId: any, authCode: any) => {

    try {

        const content = { 
            deletedAccountId: deletedAccountId, 
            authCode: authCode
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/account/deletion/confirm`, content,  getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error in confirmDoctorDeletion.', error.message);
    };

};

// --

export const getGroups = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/groups`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error in getGroups().', error.message);
    };

};


export const getGroup = async (groupId: string) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/${groupId}`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error in getGroup().', error.message);
    };

};

// -- 

export const getGroupsByDoctor = async (doctorId: any) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/groups/${doctorId}`, getConfig()); 

        return res;

    } catch (error: any) {
        console.error('Error retrieving a list of groups by doctors.', error.message);
    };

};

// -- 

export const getDeletionInfo = async (doctorId: string) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/accounts/deletion/${doctorId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getDeletionInfo()', error.message);
    };

};

// --

export const getGroupSize = async (groupId: string) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/size/${groupId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getGroupSize()', error.message);
    };

};

// --

export const getGroupAccessListWithGroupId = async (groupId: string) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/access/${groupId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getGroupAccessListWithGroupId()', error.message);
    };

};

// -- 

export const getDoctorName = async (doctorId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/info/${doctorId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getDoctorName()', error.message);
    };

};

// -- 

export const getGroupLogs = async (groupId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/logs/${groupId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getGroupLogs()', error.message);
    };

};

// -- 

export const updateGroupMainDoctor = async (groupAccessId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/main/${groupAccessId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: updateGroupMainDoctor()', error.message);
    };

};

// -- 

export const updateGroupSeats = async (groupId: string, seats: number) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/seats/${groupId}/${seats}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: updateGroupSeats()', error.message);
    };

};

// -- 

export const updateGroupStatus = async (groupId: string, status: string) => {

    try {
        
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/status/${groupId}/${status}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: updateGroupStatus()', error.message);
    };

};

// -- 

export const updateDoctorStatus = async (doctorId: string, status: string) => {

    try {
        
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/status/${doctorId}/${status}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: updateDoctorStatus()', error.message);
    };

};

// -- 

export const updateGroupAccessStatus = async (groupAccessId: string, status: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/access/${groupAccessId}/${status}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: updateGroupAccessStatus()', error.message);
    };

};

// -- 

export const getDoctorGroupAccessList = async (doctorId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/access/${doctorId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getDoctorGroupAccessList()', error.message);
    };

};

// -- 

export const getDoctor = async (doctorId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/${doctorId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getDoctor()', error.message);
    };

};

// -- 

export const getDoctorLogs = async (doctorId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/logs/${doctorId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getDoctorLogs()', error.message);
    };

};


// -- 

export const getGroupMemberInfo = async (groupAccessId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/doctor/${groupAccessId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getGroupMemberInfo()', error.message);
    };

};

// -- 

export const getGroupDataUsage = async (groupId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/usage/${groupId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getGroupDataUsage()', error.message);
    };

};

// -- 

export const getGroupSubscription = async (groupId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/group/subscription/${groupId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getGroupSubscription()', error.message);
    };

};

// -- 

export const getDoctorDataUsage = async (doctorId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/usage/${doctorId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: getDoctorDataUsage()', error.message);
    };

};

// -- 

export const getTeamMember = async (teamMemberId: string) => {

    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/member/${teamMemberId}`, getConfig()); 

        return res; 

    } catch (error: any) {
        console.error('Error: teamMemberId()', error.message);
    };

};

// --

export const getDoctorFinancials = async (doctorId: string) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/doctor/financials/${doctorId}`, getConfig()); 
        return res; 
    } catch (error: any) {
        console.error('Error: getDoctorFinancials()', error.message);
    }
};

// --

export const exportAllDoctorFinancials = () => {
    const token = Cookies.get('adminJwt');
    const url = `${process.env.REACT_APP_BACKEND_URL}/hacker/doctors/financials/export?token=${token}`;

    window.open(url, '_blank');
};

// --

export const getFaxLogs = async () => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hacker/logs/fax`, getConfig());
        return res;
    } catch (error: any) {
        console.error('Error getting fax logs:', error.message);
    };
};